import React from "react";

export const ManageArrears = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 2740 2259.8"
    enableBackground="new 0 0 2740 2259.8"
    xmlSpace="preserve"
    width= "90px"
    style={{paddingBottom: "13px"}}
  >
    <g>
      <path
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="40"
        strokeMiterlimit="10"
        d="M2564.5,95.8C2393.1-31,2150.2,5,2022.2,176.8
		c-42.1,57.3-28.6,139.5,30.3,183.2l88.8,66.3l-56.8,71.2c-313.3-175.9-619.6,59.7-714.5,144.4c-94.5-84.7-401.6-319.8-714.5-144.4
		l-56.8-71.6l88.7-65.8c58.9-43.8,72.4-126,29.4-184C589.5,5,346.6-31,175.2,95.8C41.9,194.8-11.7,364.1,38.6,527.3
		c11.9,38.4,29.4,74,51.9,105.9c43.5,60.2,128.8,75.6,189.4,29.9l88.3-65.8l80.2,100.2c-69.1,124.3-85.1,286.7-44.6,470.7
		c40.1,180,138.2,379.9,283,553.3l-200.4,214.7c-69.4,74-61.4,192.7,11.5,256c72.8,67.5,188.3,62.6,255.6-11.5L953,1967.3
		c89.6,62.9,187.7,114.4,293.7,148.8c79.2,26.1,166.7,26.2,246.2,0c0.4,0,0.4,0,0.4,0c106.3-34.8,204.5-86.3,294.5-148.9
		l197.9,213.1c68.6,74.9,183.5,78.7,256,12.3c74.8-66.7,78.7-184.2,12.3-256l-200.4-215.9c144.4-173,242.5-373,282.2-552.5
		c40.5-184.4,24.5-346.8-44.6-470.7l79.8-100.2l88.7,66.3c60.2,44.4,145,31.2,189.4-30.3C2762.5,475.3,2743.9,228.9,2564.5,95.8z
		 M230.8,597.6c-21.6,16-55,13.4-73.6-12.3c-17.6-24.5-31.1-52.3-40.5-82.2c-40.1-129.6,2-263.8,107.2-341.5
		c133.7-99.5,326.7-72.3,427.8,63.8c15.1,20.9,9.4,52.4-13.1,68.7L230.8,597.6z M434.1,548.5l99-73.6l54.9,67.2
		c-17.9,13.5-35.7,28-53.2,44.4c-14.3,13.5-27.8,27.8-40.1,42.9c1.6-1.6,2.9-3.7,4.5-5.7c-1.2,0.8-2,2-2.9,2.9L434.1,548.5z
		 M693.4,2125.5c-37.5,40.9-100.3,43.2-140.7,6.1c-41.6-36.7-42.3-101.1-6.5-139.5l196-209c44.8,48.2,93.5,93.3,145.7,135
		L693.4,2125.5z M2193.9,1992.2c34.8,37.4,35,102.5-6.5,139.9c-40.9,36.8-104.3,33.9-141.5-7l-193-206.9c-2.9,2.5-6.1,4.5-9.4,7
		c55.6-43.8,108-91.2,155.4-142.3L2193.9,1992.2z M2256.1,1150.5c-74.8,337.4-369.3,750.9-788.5,887.9c-63,20.9-132.5,20.9-195.5,0
		c-418.8-137-713.7-550.5-788.1-887.9c-47.8-216.3-10.2-395.5,106.3-504.3c235-219.3,534.5-143,750.1,80.2
		c7.4,8.2,18.4,12.7,29.4,12.7c11.5,0,22.1-4.5,29.9-12.7c16-17.2,395.9-410.6,749.7-80.2C2265.9,755.1,2303.5,934.2,2256.1,1150.5z
		 M2243,626.6c-0.2,0.2-0.1,0.2-0.3,0.4c-11.7-14.1-24-27.8-37.7-40.4c-16.4-15.7-33.1-29.3-49.8-41.9l51.9-69.7l98.6,73.2
		L2243,626.6z M2582.5,585.3c-18.5,25.6-51.8,28.4-73.6,12.3l-407.8-303.5c-22.1-16.4-28.2-47.8-12.7-69.5
		c101.1-134.8,292.2-163.6,427.4-63C2657.4,266.3,2670.8,462.1,2582.5,585.3z"
      />
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M893,794.3l38.6,34.3c10.6,9.4,11.8,25.7,2.6,36.4l0,0c-9.2,10.7-25.3,11.7-35.9,2.3l-38.6-34.3
				c-10.6-9.4-11.8-25.7-2.6-36.4l0,0C866.3,785.8,882.4,784.9,893,794.3z M735.5,1093.2l50.4,9.8c13.9,2.7,23,16.2,20.5,30.2
				c-2.5,14-15.8,23.1-29.7,20.4l-50.4-9.8c-13.8-2.7-23-16.2-20.5-30.2C708.4,1099.7,721.6,1090.5,735.5,1093.2z M1792.6,737.9
				L1792.6,737.9c10.7,9.4,11.8,25.7,2.6,36.4l-33.5,38.8c-9.2,10.7-25.3,11.7-36,2.2l0,0c-10.6-9.5-11.8-25.7-2.6-36.4l33.5-38.8
				C1765.8,729.5,1781.9,728.5,1792.6,737.9z M1121.9,601.1 M1946.3,995.6c13.2-4.9,27.9,2,32.8,15.4c4.9,13.4-1.7,28.2-14.9,33.1
				l-47.8,17.7c-13.2,4.9-27.9-2-32.8-15.4c-5-13.4,1.7-28.2,14.9-33.1L1946.3,995.6z M799.9,1419.4c13.2-4.9,27.9,2,32.8,15.4
				c4.9,13.4-1.7,28.2-14.9,33.1l-47.8,17.7c-13.2,4.9-27.9-2-32.8-15.4c-5-13.4,1.7-28.2,14.9-33.1L799.9,1419.4z M990.8,1665.7
				L990.8,1665.7c10.7,9.4,11.8,25.7,2.6,36.4l-33.5,38.7c-9.2,10.7-25.3,11.7-36,2.2l0,0c-10.6-9.4-11.8-25.7-2.6-36.4l33.5-38.7
				C964,1657.3,980.1,1656.3,990.8,1665.7z M1939.7,1327.3l50.4,9.8c13.9,2.7,23,16.2,20.5,30.2l0,0c-2.5,14-15.8,23.1-29.7,20.5
				l-50.4-9.8c-13.8-2.7-23-16.2-20.5-30.2l0,0C1912.6,1333.8,1925.9,1324.6,1939.7,1327.3z M1257.3,1797.5L1257.3,1797.5
				c13.9,2.7,23.1,16.2,20.5,30.2l-9.2,50.9c-2.5,14-15.8,23.1-29.7,20.4l-0.1,0c-13.9-2.7-23-16.2-20.5-30.2l9.2-50.9
				C1230.2,1804,1243.5,1794.8,1257.3,1797.5z M1818.2,1613.8l38.7,34.2c10.6,9.4,11.8,25.7,2.5,36.4l0,0
				c-9.2,10.7-25.3,11.7-36,2.2l-38.7-34.2c-10.6-9.4-11.8-25.7-2.6-36.4l0,0C1791.5,1605.4,1807.6,1604.4,1818.2,1613.8z
				 M1555.3,1773.7c13.2-4.9,27.9,2,32.8,15.4l17.9,48.5c4.6,12.3-0.8,25.9-12,31.8l-2.9,1.3c-13.2,4.9-27.9-2-32.8-15.4l-17.9-48.5
				C1535.4,1793.4,1542.1,1778.6,1555.3,1773.7z"
          />
        </defs>
        <clipPath id="SVGID_00000154407364777680471130000010268044435797852860_">
          <use xlinkHref="#SVGID_1_" overflow="visible" />
        </clipPath>

        <rect
          x="547.3"
          y="412"
          transform="matrix(0.938 -0.3467 0.3467 0.938 -344.3588 546.9905)"
          clipPath="url(#SVGID_00000154407364777680471130000010268044435797852860_)"
          fill="#FFFFFF"
          width="1618.3"
          height="1647.7"
        />

        <rect
          x="45.9"
          y="-1057.5"
          transform="matrix(0.938 -0.3467 0.3467 0.938 193.2464 1318.9644)"
          clipPath="url(#SVGID_00000154407364777680471130000010268044435797852860_)"
          fill="none"
          width="7473.6"
          height="2353.9"
        />
      </g>
      <g>
        <path
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="60"
          strokeMiterlimit="10"
          d="M1238.1,1379c0,83,67.3,150.3,150.3,150.3
			c83,0,150.3-67.3,150.3-150.3c0-150.3-276.5-150.3-276.5-300.6c0-67.6,43.2-126.2,126.2-126.2c83,0,126.2,63.1,126.2,126.2"
        />
        <line
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="60"
          strokeMiterlimit="10"
          x1="1388.4"
          y1="1656.9"
          x2="1388.4"
          y2="1529.3"
        />
        <line
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="60"
          strokeMiterlimit="10"
          x1="1388.4"
          y1="952.2"
          x2="1388.4"
          y2="824.6"
        />
      </g>
      <line
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="60"
        strokeMiterlimit="10"
        x1="1385.4"
        y1="1382.5"
        x2="1703.4"
        y2="1064.6"
      />
      <line
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="60"
        strokeMiterlimit="10"
        x1="1349.3"
        y1="1341"
        x2="1088.1"
        y2="1127.8"
      />
      <circle
        fill="#FFFFFF"
        stroke="#FFFFFF"
        strokeMiterlimit="10"
        cx="1379.2"
        cy="1380.4"
        r="73.3"
      />
    </g>
  </svg>
);
